"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { isNoTrackingRoute } from "@/constants/noTrackingRoutes";

const TrackingManager = dynamic(() => import("@/components/TrackingManager"), {
  ssr: false,
});

export default function TrackingManagerGate() {
  const pathname = usePathname();
  const blockTracking = isNoTrackingRoute(pathname);
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    if (blockTracking) {
      setShouldMount(false);
      return;
    }

    let mounted = true;
    const activate = () => {
      if (!mounted) return;
      setShouldMount(true);
    };

    let idleId = null;
    let timeoutId = null;

    if ("requestIdleCallback" in window) {
      idleId = window.requestIdleCallback(activate, { timeout: 2500 });
    } else {
      timeoutId = window.setTimeout(activate, 1200);
    }

    const fallbackId = window.setTimeout(activate, 5000);

    return () => {
      mounted = false;
      if (idleId !== null) window.cancelIdleCallback?.(idleId);
      if (timeoutId !== null) window.clearTimeout(timeoutId);
      window.clearTimeout(fallbackId);
    };
  }, [blockTracking]);

  if (blockTracking || !shouldMount) return null;
  return <TrackingManager />;
}
